import { defineStore } from 'pinia';

export const usePreviousRouteStore = defineStore('previousRoute', {
    state: () => ({
        path: null as string | null,
    }),
    actions: {
        set(path: string) {
            this.path = path;
        },
    },
});
